import { render, staticRenderFns } from "./Backtohome.vue?vue&type=template&id=1f74b4a4&scoped=true"
import script from "./Backtohome.vue?vue&type=script&lang=js"
export * from "./Backtohome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f74b4a4",
  null
  
)

export default component.exports